<template>
  <!-- 人员管理 -->
  <div>
    <div class="fourthStep">
      <el-form
        ref="extTable"
        :model="{ extTable }"
        :rules="tableRules"
        label-width="100px"
      >
        <el-form-item class="addTabIndex" label-width="0px" label="" prop="">
          <el-table border :data="extTable" class="" max-height="99999">
            <el-table-column width="167px;" prop="titleName" label="项目成员姓名">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.personName`"
                  :rules="tableRules.personName"
                >

                  <el-input
                    style="width: 130px"
                    v-model="scope.row.personName"
                    placeholder="请输入"
                    clearable
                    maxlength="18"
                  />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column width="167px;" prop="remark" label="手机号">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.phone`"
                  :rules="tableRules.phone"
                >

                  <el-input
                    style="width: 130px"
                    v-model.number="scope.row.phone"
                    placeholder="请输入"
                    clearable
                    maxlength="11"
                  />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column width="167px;" prop="remark" label="证件类型">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.cardType`"
                  :rules="tableRules.cardType"
                >

                  <el-select
                    style="width: 130px"
                    v-model="scope.row.cardType"
                    placeholder="请选择"
                  >
                    <el-option label="身份证" value="0"></el-option>
                    <el-option label="护照" value="1"></el-option>
                    <el-option label="其他" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column width="167px;" prop="remark" label="项目团队成员证件号">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.idCard`"
                  :rules="tableRules.idCard"
                >

                  <el-input
                    style="width: 130px"
                    v-model="scope.row.idCard"
                    placeholder="请输入"
                    clearable
                    maxlength="18"
                  />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column  prop="remark" label="职务">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.post`"
                  :rules="tableRules.post"
                >

                  <el-input
                    style="width: 150px"
                    v-model="scope.row.post"
                    placeholder="请输入"
                    clearable
                    maxlength="100"
                  />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              width="130px;"
              prop="remark"
              label="操作"
            >
              <template slot-scope="scope">
                <span
                  style="color: red;cursor: pointer;"
                  @click="deleteItem(scope)"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label-width="0px" label="">
          <div class="addBtn" @click="addTable()">+添加团队人员</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    extTable: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      checkOut:false,
      tableRules: {
        personName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          // {
          //   required: false,
          //   pattern: /^[\u4e00-\u9fa5]{2,18}$/,
          //   message: "请输入2-18个中文汉字"
          // },
          // {
          //   pattern: /^[a-zA-Z\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/,
          //   message: "只支持输入英文名称"
          // }
        ],
        cardType: [
          { required: true, message: "请输入证件类型", trigger: "change" }
        ],
        idCard: [
          { required: true, message: "请输入证件号", trigger: "blur" },
        ],
        post: [
          {
            required: true,
            message: "请输入职务",
            trigger: "blur"
          }
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^\d{11}$/,
            message: "手机号码输入错误"
          }
        ],
        fax: [{ required: true, message: "请输入传真", trigger: "blur" }],
        yesNo: [
          { required: true, message: "请选择默认联系人", trigger: "blur" }
        ],

        deviceName: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
          {
            pattern: /^[\u4E00-\u9FA5A-Za-z0-9_]+$/,
            message: "只支持中文、英文、数字"
          }
        ]
      }
    };
  },
  methods: {
    ruleFun() {
      this.$refs["extTable"].validate(valid => {

        if (valid) {
          this.checkOut=  true;
          } else {
          this.$refs.extTable.$el.scrollIntoView({
            block: "center",
            behavior: "smooth",
          });
          this.checkOut=  false;
        }
      });
    },
    // 新增
    addTable() {
      if (this.extTable && this.extTable.length === 0) {
        this.extTable.push({
          id: 1
        });
      } else {
        this.extTable.push({
          id: this.extTable[this.extTable.length - 1].id + 1
        });
      }
    },
    deleteItem(scope) {
      this.extTable.filter((item, index) => {
        if (item.id === scope.row.id) {
          this.extTable.splice(index, 1);
        }
      });
    },
    // 上一步
    lastStep() {
      this.$emit("getStep", 2);
    }
  }
};
</script>

<style lang="scss" scoped>
.fourthStep {
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.el-form-item__content .el-button {
  width: 82px;
  height: 40px;
  background: #ff152e;
  border-radius: 2px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.el-form-item__content .stopBtn {
  border: 1px solid #ff152e;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff152e;
}

.addBtn {
  cursor: pointer;
  margin: 0px 0px 10px 0px;
  width: 1006px;
  height: 32px;
  line-height: 32px;
  border: 1px dashed #eee;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #252631;
}
.addTabIndex {
  width: 100%;
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}

.addTabIndex /deep/.tbody tr {
  height: 45px !important;
}

.addTabIndex /deep/.el-form-item__content {
  width: 1006px;
  margin: 0 auto;
  border-bottom: none;
  tbody tr {
    height: 55px !important;
  }
  .el-table th>.cell:before{
    content: "*";
    color: red;
    margin-right: 5px;
  }
  .addBtn {
    width: 100%;
    height: 32px;
    line-height: 32px;
    border: 1px dashed #eee;
    border-radius: 4px;
    margin: 16px 0;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #252631;
  }
  .el-table .el-table-row .hover-row {
    background: #eee !important;
  }
}
</style>
